import React from "react";

import type { SessionMetadata } from "@app/analytics/MeetingReport/types";

import RecordingCappedBanner from "./RecordingCappedBanner";
import ReportExpirationBanner from "./ReportExpirationBanner";
import {
  SessionCancelledAlert,
  SessionErrorAlert,
  SessionRestrictedDataAlert,
  SessionUnsupportedLanguageAlert,
} from "./ReportStatusAlerts";

const SessionErrorBanner = ({
  sessionMetadata,
}: {
  sessionMetadata: SessionMetadata;
}) => {
  if (sessionMetadata.isUnsupportedLanguage) {
    return <SessionUnsupportedLanguageAlert />;
  }

  if (sessionMetadata.status === "cancelled") {
    return <SessionCancelledAlert />;
  }

  if (sessionMetadata.status === "error") {
    return <SessionErrorAlert end={sessionMetadata.endTime} />;
  }

  if (sessionMetadata.tier === "lite") {
    return <SessionRestrictedDataAlert />;
  }

  return null;
};

const MeetingReportBanners = ({
  sessionMetadata,
}: {
  sessionMetadata: SessionMetadata;
}) => {
  // don't show the recording cap banner if the recording cap is irrelevant
  // for this meeting anyway
  const showRecordingCappedBanner =
    sessionMetadata.isOverMaxSessionLength &&
    !["deleted", "notetaker", "lite"].includes(sessionMetadata.tier);

  return (
    <>
      <SessionErrorBanner sessionMetadata={sessionMetadata} />
      <ReportExpirationBanner
        show={sessionMetadata.isRestrictedReport}
        expirationDate={sessionMetadata.dataExpirationDate}
      />
      {showRecordingCappedBanner && (
        <RecordingCappedBanner
          planType={sessionMetadata.billingPlanAtTimeOfSession}
        />
      )}
    </>
  );
};

export default MeetingReportBanners;
